export default __webpack_public_path__ + "static/media/lawn-doctors-reviews-background--mobile.a9602ff8.jpg";